import script from "./TaskConfigurationList.vue?vue&type=script&setup=true&lang=ts"
export * from "./TaskConfigurationList.vue?vue&type=script&setup=true&lang=ts"

import "./TaskConfigurationList.vue?vue&type=style&index=0&id=a2f2e8be&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a2f2e8be"]])

export default __exports__